import { gql } from '@apollo/client';

export const FETCH_FUNNEL_CHART = gql`
  subscription FunnelChart($batchId: Int) {
    funnelChart(batchId: $batchId) {
      sent
      bounced
      delivered
      opened
      clicked
      conversionRate
    }
  }
`;
